angular
  .module('contrast.factory.application.trends', [])
  .factory('ApplicationTrendsFactory', function ($http, UserService) {
    'ngInject'

    return {
      getHistoryTrend: function (id, includeMerged) {
        includeMerged = includeMerged || true
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/history'),
          { params: { includeMerged: includeMerged } }
        )
      },
      getHistoryTrendByInterval: function (
        id,
        includeMerged,
        interval,
        environment
      ) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/history/interval'),
          {
            params: {
              includeMerged: includeMerged,
              interval: interval,
              environment: environment
            }
          }
        )
      },
      getDefenseHistoryTrendByInterval: function (
        id,
        includeMerged,
        interval,
        environment
      ) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + id + '/history/interval/defense'
          ),
          {
            params: {
              includeMerged: includeMerged,
              interval: interval,
              environment: environment
            }
          }
        )
      },

      getAttackTrend: function (id, includeMerged) {
        includeMerged = includeMerged || true
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/attacks'),
          { params: { includeMerged: includeMerged } }
        )
      },

      getAttackTrendByInterval: function (
        id,
        includeMerged,
        interval,
        environment
      ) {
        includeMerged = includeMerged || true
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/attacks/history'),
          {
            params: {
              includeMerged: includeMerged,
              interval: interval,
              environment: environment
            }
          }
        )
      }
    }
  })
